import "@/assets/reset.css";
import "@/assets/common.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.filter("currencyUSD", (value) => {
  return "$" + value;
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
